import Check from '@assets/icons/check.svg'
import { Icon } from './Icon'

export const CheckIcon = Icon(Check)
